import { BrowserRouter as Router, Routes, Route } from "react-router-dom"; 
import './App.css';
import Home from './user/Home';
import Login from "./auth/Login/AdminLogin";
import ProtectedAdminRoute from "./auth/ProtectedAdminRoute";
import AdminDashboard from "./admin/AdminDashboard/AdminDashboard";
import ForSale from "./user/ForSale/ForSale.jsx"
import ForRent from "./user/ForRent/ForRent.jsx"
import UpcomingProjects from "./user/UpcomingProjects/UpcomingProjects.jsx"
import ManageProjects from "./admin/ManageProjects/ManageProjects.jsx";
import UserLayout from "./components/UserLayout/UserLayout.jsx";
import AdminLayout from "./admin/AdminLayout/AdminLayout.jsx";
import PropertyDetail from "./user/PropertyDetail/PropertyDetail.jsx";
import OngoingProjects from "./user/OngoingProjects/OngoingProjects.jsx";
import AboutUs from "./user/AboutUs/AboutUs.jsx";
import Contact from './user/Contact/Contact.jsx'
import AdminRedirect from "./admin/AdminRedirect/AdminRedirect.jsx";
import ScrollToTopButton from "./components/ScrollToTopButton/ScrollToTopButton.jsx";
import PrivacyPolicy from "./user/PrivacyPolicy/PrivacyPolicy.jsx";
import TermsConditions from "./user/TermsConditions/TermsConditions.jsx";
import HeroImageUploader from "./admin/HeroImageUploader/HeroImageUploader.jsx";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          {/* ✅ User Side Routes */}
          <Route element={<UserLayout/>}>
            <Route path="/" element={<Home/>} />
            <Route path="/for-sale" element={<ForSale />} />
            <Route path="/for-rent" element={<ForRent />} />
            <Route path="/upcoming-projects" element={<UpcomingProjects/>} />
            <Route path="/ongoing-projects" element={<OngoingProjects/>} />
            <Route path="/properties/:id" element={<PropertyDetail/>} />
            <Route path="/aboutus" element={<AboutUs/>} />
            <Route path="/contact" element={<Contact/>} />
            <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
            <Route path="/terms-of-service" element={<TermsConditions/>} />
          </Route>

          {/* ✅ Admin Side Routes */}
          <Route 
            path="/admin/login" 
            element={
              <ProtectedAdminRoute>
                <Login />
              </ProtectedAdminRoute>
            } 
          />

          <Route path="/admin" element={<AdminRedirect />} />

          <Route element={<AdminLayout />}>
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedAdminRoute>
                  <AdminDashboard />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/manage-projects"
              element={
                <ProtectedAdminRoute>
                  <ManageProjects />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/heroimage-upload"
              element={
                <ProtectedAdminRoute>
                  <HeroImageUploader />
                </ProtectedAdminRoute>
              }
            />
          </Route>
        </Routes>
      </Router>
      <ScrollToTopButton/>
    </div>
  );
}

export default App;
